import React, { useState, useEffect } from "react";
  import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import UserManagmentHeader from "./UserManagmentHeader";


  const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isPasswordGenerated, setIsPasswordGenerated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [newUser, setNewUser] = useState({
      name: "",
      email: "",
      password: "",
      role: "user",
    });
    const [confirmation, setConfirmation] = useState({
      show: false,
      userId: null,
      action: "",
    });

    const fetchUsers = () => {
      const token = localStorage.getItem("token");
      console.log("Fetching users with token:", token);

      if (!token) {
        toast.error("You must be logged in to view users.");
        return;
      }
      setLoading(true);
      fetch("https://teams.tidyds.com/api/users", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
        .then((res) => {
          console.log("Response status:", res.status);
          return res.json();
        })
        .then((data) => {
          console.log("Fetched users data:", data);
          setUsers(data);
          setLoading(false);
        });
        
        
    };

    useEffect(() => {
      fetchUsers();
    }, []);

    const handleInputChange = (e) => {
      setNewUser({ ...newUser, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
      const { name, email, password } = newUser;
      const emailRegex = /\S+@\S+\.\S+/;
      if (!name || !email || !password) {
        toast.error("All fields are required.");
        return false;
      }
      if (!emailRegex.test(email)) {
        toast.error("Invalid email format.");
        return false;
      }
      if (password.length < 6) {
        toast.error("Password must be at least 6 characters.");
        return false;
      }
      return true;
    };

    const generatePassword = () => {
      const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$";
      let pass = "";
      for (let i = 0; i < 10; i++) {
        pass += charset.charAt(Math.floor(Math.random() * charset.length));
      }
      setNewUser({ ...newUser, password: pass });
      setIsPasswordGenerated(true);
    };

    const handleAddUser = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    toast.error("You must be logged in to add a user.");
    return;
  }

  let newErrors = {};
  if (!newUser.name) newErrors.name = "Name is required.";
  if (!newUser.email) {
    newErrors.email = "Email is required.";
  } else if (!/\S+@\S+\.\S+/.test(newUser.email)) {
    newErrors.email = "Invalid email format.";
  }
  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  // Generate password if missing
  let password = newUser.password;
  if (!password) {
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$";
    password = "";
    for (let i = 0; i < 10; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
  }

  const userToSend = { ...newUser, password, generated: true };

  setErrors({});
  setShowModal(false);
  setLoading(true);

  fetch("https://teams.tidyds.com/api/add-user", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(userToSend),
  })
    .then(async (res) => {
      if (!res.ok) {
        if (res.status === 422) {
          const errData = await res.json();
          console.error("Validation errors:", errData);
          toast.error(errData.message || "Validation failed.");
        }
        throw new Error("Validation failed");
      }
      return res.json();
    })
    .then((data) => {
      if (data.user) {
        setUsers([...users, { ...data.user, status: "enabled" }]);
        setNewUser({ name: "", email: "", password: "", role: "user" });
        toast.success("User added successfully!");
      }
    })
    .catch((err) => console.error("Add user error:", err))
    .finally(() => setLoading(false));
};



    const confirmAction = (id, action) => {
      setConfirmation({ show: true, userId: id, action });
    };

    const proceedAction = () => {
      const { userId, action } = confirmation;
      const token = localStorage.getItem("token");
      console.log("Proceeding with action:", action, "for user:", userId, "with token:", token);

      if (!token) {
        toast.error("You must be logged in to perform this action.");
        return;
      }

      const method = action === "delete" ? "DELETE" : "PUT";
      const url =
        action === "delete"
          ? `https://teams.tidyds.com/api/users/${userId}`
          : `https://teams.tidyds.com/api/users/${userId}/${action}`;

      fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
        .then((res) => {
          console.log(`${action} response status:`, res.status);
          return res.json();
        })
        .then(() => {
          fetchUsers();
          setConfirmation({ show: false, userId: null, action: "" });
          if (action === "delete") {
            toast.success("User deleted successfully!");
            } else if (action === "enable") {
            toast.success("User enabled successfully!");
            } else if (action === "disable") {
            toast.success("User disabled successfully!");
          }
        })
        .catch((err) => {
      console.error(`Error during ${action}:`, err);
     toast.error(`Failed to ${action} user.`);
    });
    };

    return (
      <div>
      <style>
        {`
        .add-but:hover{
        background:#6b21bf !important;
        }
        .ac-but:hover{
        background:#6b21bf !important;
        border-color:#6b21bf !important;
        color:#fff !important;
        }
        .home-but:hover{
        background:#515359 !important;
        box-shadow: none !important;
        }
        .hovrr:hover{
        border-color: #000 !important
        }
        .hovrr:focus{
        border-color: #000 !important
        box-shadow:none !important}
        `}
      </style>
        <div  style={{marginTop:"100px", padding:"0px 52px"}}>
        <UserManagmentHeader />
          <div className="card shadow-sm border-0 rounded-3">
        <div className="card-body p-0" style={{border:"1px solid #e9eaeb"}}> 
          {/* Header with Title + Add User */}
          <div className="d-flex justify-content-between align-items-center" style={{padding:"15px 24px"}}>
            <a href="https://teams.tidyds.com/admin-dashboard"><button
              className="btn btn-light fw-semibold home-but"
              style={{background:"#72757b", color:"#FFF", borderRadius: "8px", padding: "8px 15px",fontSize:"16px", fontWeight:"700", lineHeight:"24px" }}
            >
             ← Home
            </button></a>
            <h6 className=" m-0" style={{fontSize:"16px", fontWeight:"700", lineHeight:"24px"}}>Team members</h6>
            <button
              className="btn text-white add-but"
              style={{
                background:"#45048a", color:"#FFF", borderRadius: "8px", padding: "8px 15px",fontSize:"16px", fontWeight:"700", lineHeight:"24px"
              }}
              onClick={() => setShowModal(true)}
            >
              <img src="./plus.png" alt="add" style={{ width:"14px", marginRight:"10px"}} /> Add User
            </button>
          </div>

          {/* Users Table */}
          <div className="table-responsive">
            <table className="table align-middle m-0">
              <thead style={{textAlign:"center"}}>
                <tr>
                  <th scope="col"  style={{padding:"15px 24px",background: "#e9eaeb"}}>Name</th>
                  <th scope="col" style={{padding:"15px 24px",background: "#e9eaeb"}}>E-mail</th>
                  <th scope="col" style={{padding:"15px 24px",background: "#e9eaeb"}}>Role</th>
                  <th scope="col" style={{padding:"15px 24px",background: "#e9eaeb"}}>Action</th>
                  <th scope="col" style={{padding:"15px 24px",background: "#e9eaeb"}}></th>
                </tr>
              </thead>
              <tbody style={{textAlign:"center"}}>
                {users.map((user) => (
                  <tr key={user.id} >
                    {/* Profile + Name */}
                    <td className="d-flex align-items-center" style={{padding:"15px 24px"}}>
                      <img
                        src={
                          user.profile_pic
                            ? `https://teams.tidyds.com/${user.profile_pic.replace(
                                /^\/+/,
                                ""
                              )}`
                            : `https://ui-avatars.com/api/?name=${user.name}&background=random`
                        }
                        alt={user.name}
                        className="rounded-circle me-2"
                        width="40"
                        height="40"
                      />
                      {user.name}
                    </td>

                    {/* Email */}
                    <td>{user.email}</td>

                    {/* Role */}
                    <td className="text-capitalize">{user.role}</td>

                    {/* Action */}
                    <td>
                      {user.status === "enabled" ? (
                        <button
                          className="btn btn-sm ac-but"
                          style={{
                            color: "#6b21bf",
                            border: "1px solid #6b21bf",
                            borderRadius: "6px",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            padding: "5px 10px",
                          }}
                          onClick={() => confirmAction(user.id, "disable")}
                        >
                          Disable
                        </button>
                      ) : (
                        <button
                          className="btn btn-sm ac-but"
                          style={{
                            color: "#6b21bf",
                            border: "1px solid #6b21bf",
                            borderRadius: "6px",
                            fontSize: "16px",
                            fontWeight: "700",
                            lineHeight: "24px",
                            padding: "5px 10px",
                          }}
                          onClick={() => confirmAction(user.id, "enable")}
                        >
                          Enable
                        </button>
                      )}
                    </td>
                  <td  style={{padding:"15px 24px"}}>
                    {/* Delete Icon */}
                    <i
                      className="bi bi-trash text-danger ms-3 me-3"
                      style={{ cursor: "pointer", fontSize: "18px" }}
                      onClick={() => confirmAction(user.id, "delete")}
                    ><img src="./delete.png" alt="delete" style={{width:"20px"}} /></i>

                    {/* Edit Icon */}
                    {/* <i
                      className="bi bi-pencil text-secondary"
                      style={{ cursor: "pointer", fontSize: "18px" }}
                      onClick={() => console.log("edit user", user.id)}
                    ><img src="./edit.png" alt="delete" style={{width:"20px"}} /></i> */}
                  </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

          {/* ➕ Add User Modal */}
          {showModal && (
            <div className="modal fade show d-block bg-dark bg-opacity-50">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 shadow" style={{padding:"40px"}}>
                  <div className="text-center" style={{marginBottom:"40px"}}>
                    <h5 className="fw-bold m-0" style={{fontSize:"18px", fontWeight:"600", lineHeight:"28px"}}>Add your team members</h5>
                    <p className="text-muted small m-0" style={{fontSize:"16px", fontWeight:"400", lineHeight:"24px", color:"#535862"}}>
                      Add your team now and kickstart seamless collaboration on your new project.
                    </p>
                  </div>

                  <div className="modal-body p-0" style={{width:"372px", alignSelf:"center"}}>
                    {/* Name */}
                    <div className="mb-4 text-start">
                      <label className="form-label" style={{fontSize:"16px", fontWeight:"500", lineHeight:"24px"}}>Name</label>
                      <input
                        type="text"
                        name="name"
                        className={`form-control hovrr rounded-3 ${errors.name ? "is-invalid" : ""}`}
                        placeholder="Enter Name"
                        value={newUser.name}
                        onChange={handleInputChange}
                        style={{padding:"10px 16px"}}
                      />
                      {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>

                    {/* Email */}
                    <div className="mb-4 text-start">
                      <label className="form-label" style={{fontSize:"16px", fontWeight:"500", lineHeight:"24px"}}>Email</label>
                      <input
                        type="email"
                        name="email"
                        className={`form-control hovrr rounded-3 ${errors.email ? "is-invalid" : ""}`}
                        placeholder="Enter Your Email"
                        value={newUser.email}
                        onChange={handleInputChange}
                        style={{padding:"10px 16px"}}
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>

                    {/* Role */}
                    <div className="mb-5 text-start">
                      <label className="form-label" style={{fontSize:"16px", fontWeight:"500", lineHeight:"24px"}}>Role</label>
                      <select
                        name="role"
                        className={`form-select hovrr rounded-3 ${errors.role ? "is-invalid" : ""}`}
                        value={newUser.role}
                        onChange={handleInputChange}
                        style={{padding:"10px 16px"}}
                      >
                        <option value="user">User</option>
                        <option value="admin">Admin</option>
                      </select>
                      {errors.role && <div className="invalid-feedback">{errors.role}</div>}
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex justify-content-between gap-2 mt-4">
                      <button
                        className="btn fw-semibold ac-but"
                        onClick={() => setShowModal(false)}
                        style={{ border:"1px solid #45048a", fontSize:"16px", fontWeight:"700", lineHeight:"24px", padding:"8px 60px"}}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn  fw-semibold ac-but"
                        style={{ background: "#45048a", color: "#fff",fontSize:"16px", fontWeight:"700", lineHeight:"24px", padding:"8px 70px" }}
                        onClick={handleAddUser}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 🛑 Confirmation Modal */}
          {confirmation.show && (
            <div className="modal fade show d-block bg-dark bg-opacity-50">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 shadow rounded-3 p-4 text-center">
                  
                  {/* Red X Icon */}
                  <div
                    className="mx-auto d-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{
                      width: "50px",
                      height: "50px",
                      background: "#FEE2E2", // light red
                    }}
                  >
                    <span style={{ fontSize: "24px", color: "#DC2626" }}>✕</span>
                  </div>

                  {/* Title */}
                  <h5 className="fw-bold mb-2">Confirm Action</h5>
                  <p className="text-muted mb-4">
                    Are you sure want to {confirmation.action === "delete" ? "remove" : confirmation.action} this user?
                  </p>

                  {/* Buttons */}
                  <div className="d-flex justify-content-center gap-3">
                    <button
                      className="btn fw-semibold"
                      style={{
                        border: "1px solid #DC2626",
                        color: "#DC2626",
                        padding: "8px 24px",
                        borderRadius: "8px",
                        fontWeight: "600",
                      }}
                      onClick={() => setConfirmation({ show: false })}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn fw-semibold text-white"
                      style={{
                        background: "#DC2626",
                        padding: "8px 32px",
                        borderRadius: "8px",
                        fontWeight: "600",
                      }}
                      onClick={proceedAction}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <ToastContainer position="top-right" autoClose={3000} />
          {loading && (
            <div className="loader-div" style={{ zIndex: 999 }}>
              <div className="loader" role="status">
              </div>
            </div>
          )}

        </div>
      </div>
      
    );
  };

  export default UserManagement;
